<template>
  <div class="form-group mt-2 mb-3" :class="{ invalid: isInvalid() }">
    <div class="form-check">
      <input
        v-validate="config.Validation"
        ref="item"
        :type="config.InputType"
        class="form-check-input"
        :checked="value"
        :id="'check' + id"
        :name="id"
        @change="update()"
      />

      <label class="form-check-label" :for="'check' + id">
        <span
          v-if="config.Placeholder && !insurance"
          v-html="config.Placeholder"
        ></span>
        <span v-if="insurance">{{ config.Placeholder }}</span>
        <span
          class="required-star"
          v-if="insurance && config.Validation.required && config.Placeholder"
          >*</span
        >
        <span
          v-b-modal="`modal-${id}`"
          class="ml-1 font-weight-bold"
          v-if="config.popMessage"
          v-on:click="underlineClick"
          >{{ config.popMessage.popLinkText }}.</span
        >
      </label>
      <b-modal
        v-if="config.popMessage"
        :id="`modal-${id}`"
        size="lg"
        centered
        hide-footer
      >
        <div class="mt-3 mb-0" v-html="config.popMessage.popHtmlContent"></div>
      </b-modal>
      <div class="invalid-mandatory_checkbox" ref="error" v-if="isInvalid()">
        {{ config.ErrorMessage }} skal udfyldes
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    inject: {
      $validator: '$validator',
    },
    props: {
      value: String,
      options: String,
      config: String,
      id: String,
      insurance: {
        type: Boolean,
        required: false,
      },
    },
    methods: {
      underlineClick(e) {
        e.preventDefault();
      },
      update() {
        this.$emit('input', this.$refs.item.checked);
        this.$emit('doChange', this.$refs.item.checked);
      },
      isInvalid() {
        return (
          this.$store.state.componentIsInvalid &&
          this.$refs.item &&
          !this.$refs.item.checked &&
          this.config.Validation &&
          this.config.Validation.required
        );
      },
    },
    created() {
      setTimeout(() => {
        this.$validator.validate();
      }, 300);
    },
  };
</script>
<style lang="scss" scoped>
  $padLeft: 24px;
  input {
    display: none;
  }
  label {
    position: relative;
    padding-left: 10px;
    margin-bottom: 5px;
    cursor: pointer;
    &::after {
      position: absolute;
      width: 22px;
      height: 22px;
      border: 2px solid $blue60;
      background-color: #fff;
      z-index: 1;
      content: '';
      left: -$padLeft;
      top: 1px;
      .form-check-input:checked + & {
        border-color: $blue;
      }
    }
    &::before {
      width: 21px;
      height: 21px;
      z-index: 2;
      border-radius: 50%;
      content: '';
      left: -$padLeft + 0px;
      top: 2px;
      position: absolute;
      background-image: url("data:image/svg+xml;charset=utf8,%3Csvg width='16' height='15' viewBox='0 0 16 15' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M15.5 1.631c0 .759-.333 1.498-1 2.218l-.103.107-5.826 6.332c-1.239 1.342-2.293 2.38-3.164 3.113-.87.733-1.485 1.099-1.843 1.099-.377 0-.845-.183-1.405-.55-.559-.366-.92-.744-1.084-1.133-.138-.324-.268-1.012-.391-2.062A29.548 29.548 0 0 1 .5 7.341c0-.668.27-1.286.81-1.853.541-.567 1.138-.851 1.792-.851.622 0 .993.587 1.113 1.76l.028.302c.1.901.217 1.53.349 1.887.132.357.31.535.537.535.094 0 .27-.105.528-.316.258-.21.566-.498.924-.861l5.987-6.118c.503-.519.952-.911 1.348-1.177.396-.266.733-.399 1.01-.399.206 0 .354.081.442.243.088.162.132.435.132.817v.321z' fill='%2300405F' fill-rule='evenodd'/%3E%3C/svg%3E");
      background-position: center center;
      background-repeat: no-repeat;
      transform: scale(0);
      transition: 0.3s ease;
      .form-check-input:checked + & {
        transform: scale(1);
      }
    }

    span {
      font-size: 16px;
      line-height: 24px;

      ::v-deep a {
        color: inherit;
        font-weight: bold;
      }
    }
  }
</style>
